/**
 *  路由文件
 * keepAlive: true 代表需要做页面缓存
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 自动导入 router/modules 下的所有模块
const modulesFiles = require.context('./modules', true, /\.js$/)
const modulesRoutes = modulesFiles.keys().reduce((routes, path) => {
  const moduleRoutes = modulesFiles(path).default
  return routes.concat(moduleRoutes)
}, [])

const constantRoutes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: { title: '首页' }
  },
  // 这是测试调试页面
  // {
  //   path: "/test",
  //   name: "test",
  //   component: () => import("../views/test/test.vue"),
  //   meta: { title: "Test" },
  // },
  // 1.以下是往届服务路由
  {
    path: '/previousservice',
    name: 'previousservice',
    component: () => import('../views/previousservice/index.vue'),
    meta: { title: '往届服务', keepAlive: true }
  },
  {
    path: '/previousservice/addservice',
    name: 'addpreviousservice',
    component: () => import('../views/previousservice/addservice.vue'),
    meta: { title: '添加服务' }
  },
  // 2.以下是清华二代子女调查表路由
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: () => import('../views/questionnaire'),
    meta: { title: '清华经管EMBA二代子女成长教育与职业规划' }
  },
  {
    path: '/questionnaire/login',
    name: 'QuestionnaireLogin',
    component: () => import('../views/questionnaire/login.vue'),
    meta: { title: '本人信息' }
  },
  {
    path: '/questionnaire/child',
    name: 'QuestionnaireChild',
    component: () => import('../views/questionnaire/child.vue'),
    meta: { title: '子女信息' }
  },

  {
    path: '/questionnaire/commitinfo',
    name: 'QuestionnaireCommiInfo',
    component: () => import('../views/questionnaire/commitbaseinfo.vue'),
    meta: { title: '调研信息' }
  },
  {
    path: '/questionnaire/childdetail',
    name: 'QuestionnaireChildDetail',
    component: () => import('../views/questionnaire/commitdetailinfo.vue'),
    meta: { title: '调研信息' }
  },
  // 3.以下是校园艺术节路由
  {
    path: '/art/allrank',
    name: 'singallrank',
    component: () => import('../views/artholiday/music/allrank.vue'),
    meta: { title: '歌手大赛总排名' }
  },
  {
    path: '/art/grouprank',
    name: 'singgrouprank',
    component: () => import('../views/artholiday/music/grouprank.vue'),
    meta: { title: '歌手大赛小组分数' }
  },
  {
    path: '/art/vote',
    name: 'singvote',
    component: () => import('../views/artholiday/music/vote.vue'),
    meta: { title: '歌手大赛投票' }
  },
  {
    path: '/art/paint',
    name: 'drawphoto',
    component: () => import('../views/artholiday/drawphoto/index.vue'),
    meta: { title: '绘画和摄影大赛', keepAlive: true }
  },
  {
    path: '/art/lottery',
    name: 'artlottery',
    component: () => import('../views/artholiday/lottery/lottery.vue'),
    meta: { title: '艺术节抽奖' }
  },
  // 4.以下是批改作业
  // {
  //   path: "/homework",
  //   name: "homework",
  //   component: () => import("../views/homework/homework.vue"),
  //   meta: { title: "培诺-AI" },
  // },
  //5.以下是Alevel学分计算
   {
    path: '/fraction/alevel',
    name: 'fractioncalculate',
    component: () => import('../views/fraction/alevel.vue'),
    meta: { title: 'alevel分数计算' }
  },
  {
    path: '/fraction/ig',
    name: 'fractionIg',
    component: () => import('../views/fraction/ig.vue'),
    meta: { title: 'ig分数计算' }
  },
  //6.以下是cc云课堂回放相关
  {
    path: '/ccroom/missing',
    name: 'CcroomMissing',
    component: () => import('../views/ccroom/missing.vue'),
    meta: { title: 'cc云课堂回放缺失资源同步获取' }
  },
  //7.视频播放
  {
    path: '/video/play',
    name: 'VideoPlay',
    component: () => import('../views/video/play.vue'),
    meta: { title: '视频播放' }
  },

  ...modulesRoutes,

  {
    path: '/demo/captcha',
    name: 'DemoCaptcha',
    component: () => import('@/views/demo/captcha.vue'),
    meta: { title: '家校通' }
  },
  // 404 page must be placed at the end !!!
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const createRouter = () =>
  new VueRouter({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
// 重置路由
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
